export type SignInFormValues = {
  email: string
  password: string
}

export type SignInFormProps = {
  onSubmit: (values: SignInFormValues) => Promise<void>
  onSuccess?: () => void
  onError?: (error: string) => void
  scid?: number
  source?: 'C' | 'CM'
  expiredError?: string
  passwordChangeRequired?: boolean
  errorCode?: string
}

export type ChallengeData = {
  UserId: string
  ChallengeId: string
}

export enum SignInStep {
  Credentials = 'credentials',
  TwoFactor = 'twoFactor',
}

export const LOGIN_ERRORS = {
  403: 'Invalid Email or Password',
  404: 'An error occurred while signing in',
  429: 'Too many failed login attempts. Please wait a few minutes or reset your password.',
} as const
